import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicNavbar from '../../components/PublicNavbar';
import Footer from '../../components/Footer';

export default function RefundPolicy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('refund.title', 'Refund Policy')}</h1>
        <p className="text-sm text-gray-500 mb-8">{t('terms.lastUpdated', 'Last updated')}: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="prose prose-gray max-w-none">
          <h2>{t('refund.s1Title', '1. Free Trial')}</h2>
          <p>{t('refund.s1Body', 'BuildMyShifts offers a 14-day free trial with full access to all features. No payment information is required to start the trial. If you do not subscribe at the end of the trial, your account will be limited to read-only access.')}</p>

          <h2>{t('refund.s2Title', '2. Monthly Subscriptions')}</h2>
          <p>{t('refund.s2Body', 'Subscriptions are billed monthly. You can cancel at any time and retain access until the end of your current billing period.')}</p>

          <h2>{t('refund.s3Title', '3. Refund Eligibility')}</h2>
          <p>{t('refund.s3Body', 'Refunds are available within the first 14 days of a paid subscription or within 7 days of an accidental renewal. To request a refund, contact us with your account email and reason for the refund.')}</p>

          <h2>{t('refund.s4Title', '4. Exceptions')}</h2>
          <p>{t('refund.s4Body', 'Refunds are not available if: you have actively used the service beyond the trial period, the subscription has been active for more than 14 days, or the request is for a period already consumed.')}</p>

          <h2>{t('refund.s5Title', '5. How Refunds Are Processed')}</h2>
          <p>{t('refund.s5Body', 'Approved refunds are processed via Stripe to your original payment method within 5–10 business days. You will receive an email confirmation once the refund is initiated.')}</p>

          <h2>{t('refund.s6Title', '6. Cancellation')}</h2>
          <p>{t('refund.s6Body', 'You can cancel your subscription at any time from your account settings. Cancellation takes effect at the end of the current billing period — you will not be charged again.')}</p>

          <h2>{t('refund.s7Title', '7. Contact')}</h2>
          <p>{t('refund.s7Body', 'For refund requests or billing questions, contact us at')} <a href="mailto:support@buildmyshifts.com" className="text-primary">support@buildmyshifts.com</a>.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
